module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"lock_page":"Lock page","show_deleted":"Show deleted"},"de":{"lock_page":"Seite sperren","show_deleted":"Sendung gelöscht"}}')
  delete Component.options._Ctor
}
